const routes = [{
  path: '/organization',
  component: () => import('@/views/organization'),
  name: 'organization',
  meta: {
    title: '组织管理/机构管理'
  }
}, {
  path: '/organization/detail',
  component: () => import('@/views/organization/detail'),
  name: 'organization-detail',
  meta: {
    title: '组织管理/机构管理/详情'
  }
}, {
  path: '/organization/seat',
  component: () => import('@/views/organization/seat'),
  name: 'organization-seat',
  meta: {
    title: '组织管理/坐席管理'
  }
}, {
  path: '/organization/personnel',
  component: () => import('@/views/organization/personnel'),
  name: 'organization-personnel',
  meta: {
    title: '组织管理/人员管理'
  }
}, {
  path: '/organization/payee',
  component: () => import('@/views/organization/payee'),
  name: 'organization-payee',
  meta: {
    title: '组织管理/收款人管理'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/organization.js